import { render } from "./BottomBar.vue?vue&type=template&id=407570bb&scoped=true&ts=true"
import script from "./BottomBar.vue?vue&type=script&lang=ts"
export * from "./BottomBar.vue?vue&type=script&lang=ts"

import "./BottomBar.vue?vue&type=style&index=0&id=407570bb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-407570bb"]])

export default __exports__